import React, { useState } from 'react';
import { useCSS } from '../../lib/hooks';

import RibbonCollection from '../ui_items/RibbonCollection';

const SelectRibbon = ({ items, ...props }) => {
	useCSS('assets/ribbon_selector.css');

	const [ opened, setOpened ] = useState(false);
	const [ value, setValue ] = useState(props?.value ?? '');

	const position = props?.position ?? 'top';
	const h_position = props?.h_position ?? 'right';

	const click = (id) => {
		if(props.onSelect != undefined) props.onSelect(props.item_id, id);
		setValue(id);
		setOpened(false);
	};

	const parsed_items = [];
	items.map((item) => {
		const _cl = item?._class ?? {};
		if(_cl.other == undefined) _cl.other = '';

		if(item.k == value) _cl.other += ' selected';

		parsed_items.push({
			...item,
			_class:_cl,
			title:item.v,
			onClick:() => click(item.k),
		});
	});

	const _selected_item = parsed_items.find((r) => (r.k == value));

	const selected_item = { ..._selected_item };
	selected_item.onClick = () => setOpened(!opened);
	selected_item.icon = 'knk-edit';

	return (
		<div class="selector_ribbon">
			<RibbonCollection
				items={[selected_item]}
			/>

			{(opened) && (
				<div class={`ribbon_picker ${position} ${h_position}`}>
					<RibbonCollection
						items={parsed_items}
					/>
				</div>
			)}
		</div>
	)
};

export default SelectRibbon;